import type {
  APIGroupActor,
  APIPermissionActor,
  APIPermissionContextBase,
  APIUserActor,
  SavePermissionsSet,
  SaveResourcePermissionsActor,
} from '@ardoq/api-types';
import { isEqual } from '@ardoq/common-helpers';

const toSaveResourcePermissionsActor = (
  actor: APIPermissionActor
): SaveResourcePermissionsActor => ({
  _id: actor._id,
  accessLevel: actor.accessLevel,
  displayName: actor.displayName,
});

const hasSomeAccess = (actor: APIPermissionActor): boolean =>
  actor.accessLevel !== 'none';

export const createPermissionsSaveRequest = (
  groups: APIGroupActor[],
  users: APIUserActor[],
  entireOrganization: APIGroupActor | null
): SavePermissionsSet => ({
  groups: groups.filter(hasSomeAccess).map(toSaveResourcePermissionsActor),
  users: users.filter(hasSomeAccess).map(toSaveResourcePermissionsActor),
  entireOrganization:
    entireOrganization && hasSomeAccess(entireOrganization)
      ? toSaveResourcePermissionsActor(entireOrganization)
      : null,
});

export const permissionContextIsModified = (
  initialPermissionContext: APIPermissionContextBase,
  permissionContext: APIPermissionContextBase
): boolean =>
  !isEqual(
    createPermissionsSaveRequest(
      initialPermissionContext.groups,
      initialPermissionContext.users,
      initialPermissionContext.entireOrganization
    ),
    createPermissionsSaveRequest(
      permissionContext.groups,
      permissionContext.users,
      permissionContext.entireOrganization
    )
  );
